import { EAccountRoles, EAccountStatuses } from 'src/types'

export const isAccountOwner = (roles: EAccountRoles[], status?: EAccountStatuses) =>
  roles.includes(EAccountRoles.owner) && (status ? status === EAccountStatuses.active : true)
